import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import RegistersFilter from 'components/UI/PageSearch/filters/RegistersFilter'
import ActionCreateModal from 'components/Modals/CreateActionModal/index'
import ActionsTable from './components/Table'
import CreateActionButton from 'components/CTAs/CreateActionButton'
import MainLayoutContainer from 'containers/MainLayout/index'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import Search from 'components/UI/PageSearch'
// context
import { ActionsPageContext } from 'containers/Actions/Register/layers/API'
// hooks
import { useCurrentUser } from 'hooks/index'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'

const Actions: React.FC = () => {
  const { config, isLoading, pageFilter } = React.useContext(ActionsPageContext)

  const {
    permissionsFromSecurityGroups: { createAction }
  } = useCurrentUser()

  return (
    <>
      <Helmet>
        <title>Skefto - {pageFilter || 'Actions'}</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        CTA={
          <>
            <Search filter={RegistersFilter} />
            {createAction && <CreateActionButton />}
          </>
        }>
        <NavigationSidebar config={config} />
        <LayoutContainerInnerWrapper>
          <ActionsTable />
        </LayoutContainerInnerWrapper>

        <ActionCreateModal />
      </MainLayoutContainer>
    </>
  )
}

export default Actions
